<!--
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-14 15:07:05
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-03-12 11:16:31
 * @FilePath: /lobby/src/components/ListGames.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div>
    <DhGameTitle
      v-if="showTitle"
      :tabItem="{ name: funTab.name, cover: funTab.cover, localName: funTab.localName }"
      :callback="onAllGames"
    />
    <div class="skeleton" v-if="isLoading">
      <div class="skeleton-content" v-for="(item, index) in rowslist" :key="index">
        <div class="skeleton-left">
          <div class="skeleton-image"></div>
          <div class="skeleton-text">
            <div class="skeleton-text-1"></div>
            <div class="skeleton-text-1"></div>
            <div class="skeleton-text-1"></div>
          </div>
        </div>
        <div class="skeleton-right"></div>
      </div>
    </div>
    <div v-else class="game-content">
      <div class="game" v-if="games.length > 0">
        <div
          class="game-group"
          v-for="(game, index) in this.games"
          :key="index"
          @click="getGameUrl(game)"
        >
          <div class="game-left">
            <div class="game-icon" :style="`background-image: url(${game.cover})`" alt="">
              <div class="list_collect" @click.stop="onCollect(game)">
                <i :class="`bi bi-suit-heart-fill ${game.isCollect ? 't_red' : ''}`"></i>
              </div>
              <div class="jackpots" v-if="game && game.jackpots && parseFloat(game.jackpots) > 0">
                <span style="font-weight: 700">JP</span>&nbsp;&nbsp;{{ formatMoney(game.jackpots) }}
              </div>
            </div>
            <div class="game-info">
              <!-- <div style="font-size: 0.18rem; color: #00cf34; height: 0.05rem">
                <i class="bi bi-people-fill"></i
                ><span style="color: white; line-height: 0.2rem; opacity: 0.75"
                  >&nbsp;{{ formatMoney(Math.floor(Math.random() * 90000) + 10000, 0) }}</span
                >
              </div> -->
              <PersonComponents :game="game" />
              <div class="game-name">
                {{ truncateText(game.name, 31) }}
              </div>
              <div class="game-tag">
                <div
                  :class="
                    game.tag.concat(game.gameplayTag).length > 4
                      ? 'scroll-continer playAnimation'
                      : 'scroll-continer'
                  "
                >
                  <!-- <div
                    :class="`tag ${getColor(tag)}`"
                    v-for="(tag, index) in game.tag.concat(game.gameplayTag)"
                    :key="index"
                  >
                    {{ tag }}
                  </div> -->
                  <div
                    class="tag"
                    v-for="(tag, index) in game.tag.concat(game.gameplayTag)"
                    :key="index"
                  >
                    <img v-if="getIcon(tag)" :src="getIcon(tag)" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="game-play">Play</div>
        </div>
      </div>
      <div style="height: 0.1rem" />
      <Empty
        v-if="isHome ? games.length == 0 : games.length < 4"
        :showicon="games.length == 0"
        :callback="onReload"
        :hideRecommend="funTab.name != 'History'"
      />
    </div>
  </div>
</template>
<script>
import { useLobbyStore } from '@/stores/lobby'
import DhGameTitle from '@/components/GameTitle.vue'
import Empty from '@/components/Empty.vue'
import { mapActions, mapState } from 'pinia'
import { config } from '@/common/config'
import { BUS, POPUP } from '@/event/EventCenter'
import { useUserStore } from '@/stores/user'
import { truncateText, formatMoney } from '@/utils/helper'
import { showSuccessToast, showToast } from 'vant'
import PersonComponents from '@/components/PersonComponents.vue'
// import { getRandomIntInclusive } from '@/utils/helper'
export default {
  name: 'DhListGames',
  components: {
    DhGameTitle,
    Empty,
    PersonComponents
  },
  props: {
    funTab: {
      type: {},
      default: {}
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    isHome: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: true,
      games: [],
      resBaseUrl: config.resBaseUrl,
      rowslist: []
    }
  },
  computed: {
    ...mapState(useLobbyStore, ['gameList', 'currentNavTabItem']),
    ...mapState(useUserStore, ['country', 'isLogin', 'balance'])
  },
  mounted() {
    this.rowslist = []
    for (let i = 0; i < this.funTab.rows; i++) {
      this.rowslist.push(i)
    }
    this.onReload(true)
  },

  methods: {
    truncateText,
    formatMoney,
    ...mapActions(useLobbyStore, {
      getGameList: 'getGameList',
      getBannersHomeTop: 'getBannersHomeTop',
      enterGame: 'enterGame',
      updatecollectGameId: 'updatecollectGameId',
      favorite: 'favorite'
    }),
    getColor(tag) {
      const mtag = tag.toUpperCase()
      if (mtag == 'NEW') {
        return 'green_bg'
      } else if (mtag == 'HOT') {
        return 'red_bg'
      } else if (mtag == 'EXCLUSIVE') {
        return 'yellow_bg'
      } else {
        return 'blue_bg'
      }
      // return ['red_bg', 'green_bg', 'yellow_bg', 'blue_bg'][getRandomIntInclusive(0, 3)]
    },
    getIcon(tag) {
      const type = tag.toUpperCase()
      if (type == 'NEW') {
        return this.resBaseUrl + 'icon_new.png'
      } else if (type == 'HOT') {
        return this.resBaseUrl + 'icon_hot.png'
      } else if (type == 'LIVE') {
        return this.resBaseUrl + 'icon_live.png'
      } else if (type == 'BONUS GAME') {
        return this.resBaseUrl + 'icon_bonus.png'
      } else {
        return false
      }
    },
    onAllGames() {
      this.$router.push({ name: 'allgame', params: { categorie: JSON.stringify(this.funTab) } })
    },
    getGameUrl(game) {
      if (!game) {
        return
      }
      if (this.isLogin) {
        this.enterGame(parseInt(game.gameId)).then((response) => {
          this.$router.push({ name: 'gameView', params: { currentGameUrl: response.url } })
        })
      } else {
        this.$bus.$emit(BUS.SHOW_POPUP, { from: 'listGame', to: POPUP.LOGIN, show: true })
      }
    },
    onReload(isfirst = false) {
      if (isfirst || (!this.isLoading && this.funTab.id)) {
        this.isLoading = true
        this.getGameList(this.funTab.id, '', 1, this.isHome ? this.funTab.rows : 999)
          .then((response) => {
            this.games = response.games
          })
          .catch(() => {
            this.games = []
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    onCollect(game) {
      if (!this.isLogin) {
        this.updatecollectGameId(game.gameId)
        this.$bus.$emit(BUS.SHOW_POPUP, { from: 'collect', to: POPUP.LOGIN, show: true })
      } else {
        this.favorite(game.gameId, !game.isCollect).then((res) => {
          if (res.result) {
            if (!game.isCollect) {
              showSuccessToast({
                message: this.$t('common.collect'),
                wordBreak: 'break-word',
                className: 'toast_success_40',
                duration: 3000
              })
            } else {
              showToast({ message: this.$t('common.uncollect'), duration: 3000 })
            }
            // this.onReload()
            this.games.map((item) => {
              if (item.gameId == game.gameId) {
                item.isCollect = !game.isCollect
              }
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.skeleton {
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  animation: blink 2s linear infinite;

  .skeleton-content {
    display: flex;
    width: 100%;
    height: 1.4rem;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.2rem;

    .skeleton-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 1.4rem;

      .skeleton-image {
        width: 2rem;
        height: 1.4rem;
        background-color: #ffffff;
      }

      .skeleton-text {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        width: 3rem;
        height: 1.4rem;
        margin-left: 0.2rem;

        .skeleton-text-1 {
          width: 100%;
          height: 0.24rem;
          background-color: #ffffff;
          margin-bottom: 0.2rem;
        }
      }
    }

    .skeleton-right {
      width: 1rem;
      height: 0.8rem;
      background-color: #ffffff;
    }
  }
}

.game-content {
  .game-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 1.4rem;
    margin-bottom: 0.2rem;

    .game-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 1.4rem;

      .game-icon {
        width: 2rem;
        height: 1.4rem;
        border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
        background-size: 100%;
        background-position-y: -0.2rem;

        .list_collect {
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgba(0, 0, 0, 0.5);
          float: right;
          width: 0.38rem;
          height: 0.28rem;
          padding-top: 0.1rem;
          margin-top: -0.4rem;
          border-radius: 50%;
          position: relative;
          text-align: center;
          z-index: 10;
          bottom: -0.45rem;
          right: 0.05rem;

          i {
            font-size: 0.24rem;
            color: #999999;
          }
        }

        .jackpots {
          display: flex;
          justify-content: center;
          align-content: center;
          width: 50%;
          // height: 0.2rem;
          background: rgba(0, 0, 0, 0.5);
          border-radius: 0.14rem;
          font-size: 0.16rem;
          padding: 0.01rem 0.05rem;
          margin: 0.03rem 25% -0.4rem 25%;
        }
      }

      .game-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        width: 3rem;
        height: 1.4rem;
        margin-left: 0.2rem;

        .game-name {
          width: 100%;
          height: auto;
          overflow-wrap: break-word;
          font-size: 0.3rem;
          line-height: 0.32rem;
          font-weight: bold;
          font-family: 'Droid Sans', Roboto, Arial, sans-serif;
          color: #fff;
          opacity: 0.75;
          margin: 0px;
          padding: 0.2rem 0 0 0;
        }

        .game-tag::-webkit-scrollbar {
          height: 0;
          /* 隐藏滚动条，但保持滚动功能 */
          display: none;
        }

        .game-tag {
          display: flex;
          justify-content: flex-start;
          width: 100%;
          height: auto;
          // padding: 0, 0, 0.2rem, 0;
          overflow-x: scroll;
          -ms-overflow-style: none;
          /* 隐藏滚动条，但保持滚动功能（仅针对IE和Edge） */

          .playAnimation {
            animation: scroll 30s linear infinite;
          }

          .scroll-continer {
            display: flex;
            justify-content: flex-start;
            width: max-content;
            height: auto;

            .tag {
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.18rem;
              line-height: 0.24rem;
              color: #fff;
              text-align: center;
              height: auto;
              width: auto;
              padding-right: 0.1rem;
              // padding-left: 0.1rem;
              margin-right: 0.1rem;
              border-radius: 0 0.1rem 0.1rem 0;
              float: left;
              position: relative;
              z-index: 4;
              display: inline;
              box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.4);

              img {
                width: auto;
                height: 0.58rem;
              }
            }
          }
        }
      }
    }

    .game-play {
      font-size: 0.32rem;
      line-height: 1rem;
      color: #fff;
      text-align: center;
      background-color: #aa884a;
      width: 1.8rem;
      height: 1rem;
      margin-top: 0.2rem;
      border-radius: 0.12rem;
      float: right;
    }
  }
}

.t_red {
  color: #ff0000 !important;
}

.red_bg {
  background-color: #f00;
}

.green_bg {
  background-color: #00ab40;
}

.yellow_bg {
  background-color: #ffbe00;
}

.blue_bg {
  background-color: #0068b7;
}

@keyframes blink {
  0%,
  100% {
    opacity: 0.3;
  }

  50% {
    opacity: 0;
  }
}

@keyframes scroll {
  0% {
    transform: translateX(0%);
  }

  50% {
    transform: translateX(calc(-100% + 3rem));
  }

  100% {
    transform: translateX(0%);
  }
}
</style>
